import ExcelGrid from "components/Custom/ExcelGrid";
import { LABELS } from "common/lables";
import React, { useEffect, useRef, useState } from "react";
import Loader from "components/Custom/Loader";

const ItemSummary = (props: any) => {
  const { salesOrderRef } = props;
  const summaryRef: any = useRef();
  const [summaryRows, setSummaryRows] = useState<any[]>(null);
  const rowsItem = salesOrderRef.getSelectedRows();

  let total = 0;

  const summaryCols = [
    {
      key: "item",
      type: "text",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.ITEM_NAME,
      width: "40%",
    },
    {
      key: "totalStrip",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.TOTAL_STRIP_PACKET,
      width: "20%",
      renderSum: true,
    },
    {
      key: "Bag",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.BAG_CARTON,
      width: "20%",
    },
    {
      key: "stripPacket",
      type: "number",
      editable: false,
      sortable: false,
      searchable: false,
      name: LABELS.STRIP_PACKET,
      width: "20%",
    },
  ];

  useEffect(() => {
    getSummaryRows();
  }, []);

  const getSummaryRows = () => {
    console.log("rowsItem", rowsItem);
    let listItem = [];
    for (let j = 0; j < rowsItem.length; j++) {
      rowsItem[j].items &&
        rowsItem[j].items.map((q) => {
          // todosku and sku*grams.qty to be multiplied
          return listItem.push({
            item: q.productName,
            totalStrip: q.soldSku,
            Bag: "0",
            stripPacket: "0",
          });
        });
    }
    setSummaryRows(listItem);
  };
  console.log("total", total);
  return (
    <>
      {summaryRows != null && (
        <ExcelGrid
          id={"summaryGrid"}
          childRef={summaryRef}
          cols={summaryCols}
          rows={summaryRows}
          noTotalRows={true}
        />
      )}
    </>
  );
};
export default ItemSummary;
